import { Typography } from "@mui/material";

export default function StatCell({
  topLabel,
  bottomLabel,
  topBgColor,
  bottomBgColor,
}: {
  topLabel: string;
  bottomLabel: string;
  topBgColor?: string;
  bottomBgColor?: string;
}) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", lineHeight: 1.4 }}>
      <span
        style={{
          backgroundColor: topBgColor,
          borderRadius: 4,
          padding: topBgColor ? "0 4px" : undefined,
        }}
      >
        {topLabel}
      </span>
      <Typography
        component="div"
        sx={{
          color: "text.secondary",
          fontSize: "0.85em",
          bgcolor: bottomBgColor,
          borderRadius: 1,
          px: bottomBgColor ? 0.5 : undefined,
        }}
      >
        {bottomLabel}
      </Typography>
    </div>
  );
}
